import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async getWebexAccessToken ({ state }, data) {
      try {
        let response = (await Vue.http({
          method: 'post',
          url: this.state.baseUrl + '/users/webex/accesstoken/_create',
          data: { oAuthCode: data.code, redirectUri: data.redirectUri }
        })).data

        console.log('getWebexAccessToken', response.accessToken)
        console.log('user', response.user)
        localStorage.setItem('webexTokens', JSON.stringify(response.accessToken))
        localStorage.setItem('user', JSON.stringify(response.user))
        return response.accessToken
      } catch (e) {
        console.log(e)
      }
    },
    async getWebexAccessTokenFromRefreshToken ({ state }) {
      try {
        let webexTokens = JSON.parse(localStorage.webexTokens)

        let response = (await Vue.http({
          method: 'post',
          url: this.state.baseUrl + '/users/webex/accesstoken/_refresh',
          data: { oAuthRefreshToken: webexTokens.refreshToken },
        })).data

        localStorage.setItem('webexTokens', JSON.stringify(response))
        return response
      } catch (e) {
        console.log(e)
      }
    },
    async getValidAccessToken ({ dispatch }) {
      let webexTokens = JSON.parse(localStorage.webexTokens)
      if (new Date().getTime() > webexTokens.accessTokenExpiresOn) {
        if (new Date().getTime() < webexTokens.refreshTokenExpiresOn) {
          return await dispatch('getWebexAccessTokenFromRefreshToken')
        }
        else {
          return null
        }
      }
      else {
        return JSON.parse(localStorage.webexTokens)
      }
    },
    async getWebexGuestAccess ({ state }) {
      try {
        let user = JSON.parse(localStorage.user)

        let response = (await Vue.http.post(this.state.baseUrl + '/users/webex/guestaccesstoken/_create', {
          participantId: user.patientId,
          participantName: user.firstName + ' ' + user.lastName
        })).data

        localStorage.setItem('webexTokens', JSON.stringify(response))
        return response
      } catch (e) {
        console.log(e)
      }
    },
    async getValidWebexGuestAccessToken ({ dispatch }) {
      let webexTokens = JSON.parse(localStorage.webexTokens)
      if (new Date().getTime() > webexTokens.accessTokenExpiresOn) {
        return await dispatch('getWebexGuestAccess')
      }
      else {
        return JSON.parse(localStorage.webexTokens)
      }
    },
    async createWebexRoom ({ state }, data) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/appointments/webex/rooms/_setup', data)).data
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async triggerCall ({ state }, data) {
      try {
        return (await Vue.http.get(this.state.baseUrl + "/appointments/webex/rooms/_triggercall?appointmentId=" +
          data._id)).data
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async deleteWebexRoom ({ state }, appointmentId) {
      try {
        await Vue.http.get(this.state.baseUrl + "/appointments/webex/rooms/_delete?appointmentId=" + appointmentId +
          "&endcall=true")
      } catch (e) {
        console.log(e)
      }
    },
  }
}
